import { render } from "./language-switcher.vue?vue&type=template&id=66f08f0a&scoped=true&ts=true"
import script from "./language-switcher.vue?vue&type=script&lang=ts"
export * from "./language-switcher.vue?vue&type=script&lang=ts"

import "./language-switcher.vue?vue&type=style&index=0&id=66f08f0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f08f0a"]])

export default __exports__